import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    mainWrapper: {
        display: 'flex',
        border: `1.5px solid ${theme.colors.grey_light}`,
        // minHeight: 'calc(100vh - 225px)',
        // height: 'calc(100vh - 225px)',
        flex: '1 1 0',
        minHeight: 0,
        overflow: 'hidden',
        background: theme.colors.white,
    },

    // Left panel: groups list. Kept as a narrow column on tablet too (2-panel
    // split); on phone it moves into a slide-in drawer and isn't rendered here.
    sideWrapper: {
        flex: '0 0 auto',
        width: '20%',
        maxWidth: 320,
        background: theme.colors.white,
        borderRight: `1.5px solid ${theme.colors.grey_light}`,
        minWidth: 260,
        alignSelf: 'stretch',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        [theme.down('desktop')]: {
            minWidth: 240,
            width: 260,
        },
    },

    centerWrapper: {
        flex: '1 1 0',
        minWidth: 0,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
    },

    groupsDrawerTrigger: {
        display: 'none',
        [theme.down('mobile')]: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: theme.spacing(2),
            minHeight: 44,
            margin: theme.spacing(2.5),
            marginBottom: 0,
            padding: `0 ${theme.spacing(4)}px`,
            borderRadius: 22,
            border: `1px solid ${theme.colors.grey_light}`,
            background: theme.colors.surface_elevated,
            color: theme.colors.violet_primary,
            fontFamily: theme.font.primary,
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
        },
    },

    groupsDrawerTriggerName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '60vw',
    },

    groupsDrawerContent: {
        width: 'min(320px, 85vw)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: theme.colors.white,
    },

    headerWrapper: {
        height: 72,
        minHeight: 72,
        maxHeight: 72,
        width: '100%',
        flexShrink: 0,
        [theme.down('desktop')]: {
            height: 72,
            minHeight: 72,
            maxHeight: 72,
        },
    },

    editWrapper:{
        marginRight: theme.spacing(6),
    },

    contentWrapper: {
        display: 'flex',
        flex: 1,
        minHeight: 0,
        [theme.down('desktop')]: {
            flexDirection: 'column',
        },
    },

    contentPanel: {
        display: 'flex',
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
    },

    tabsContainer: {
        display: 'none',
        [theme.down('desktop')]: {
            display: 'flex',
            gap: theme.spacing(2),
            padding: theme.spacing(2.5),
            background: theme.colors.white,
            borderBottom: `1.5px solid ${theme.colors.grey_light}`,
        },
    },

    contentTab: {
        flex: 1,
        minHeight: 44,
        borderRadius: 22,
        border: `1px solid ${theme.colors.grey_light}`,
        background: 'transparent',
        color: theme.colors.grey_text,
        fontFamily: theme.font.primary,
        fontSize: 15,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background .2s ease, color .2s ease, border-color .2s ease',
        '&[data-active="true"]': {
            background: theme.colors.transp_violet,
            borderColor: theme.colors.violet_primary,
            color: theme.colors.violet_primary,
        },
    },

}));
